import { Paper } from '@mui/material'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import { useCallback, useState } from 'react'
import { navIcons } from '../constants'
import { CmsContent } from '@wolfdanepug/common-react'
import { useNavigate } from 'react-router'

const Navigation = ({ items = [] }: any) => {
	const [value, setValue] = useState(0)
	const navigate = useNavigate()

	const handleChange = useCallback(
		(event: any, newValue: any) => {
			if (value !== newValue) {
				setValue(newValue)
				const { url } = items[newValue]
				navigate(url)
			}
		},
		[items, navigate, value]
	)

	return (
		<BottomNavigation
			showLabels
			value={value}
			sx={{
				bgcolor: 'black',
				color: '#fff'
			}}
			onChange={handleChange}
		>
			{items.length > 0 &&
				items.map((item: any, index: number) => {
					const Icon = navIcons[item.icon]
					return (
						<BottomNavigationAction
							key={`nav-item-${index}`}
							label={item.title}
							icon={<Icon />}
							sx={{
								color: '#fff'
							}}
						/>
					)
				})}
		</BottomNavigation>
	)
}

export const BottomNavigationControl = ({ items = [] }) => {
	return (
		<Paper
			sx={{ display: { xs: 'block', md: 'none' }, position: 'fixed', bottom: 0, left: 0, right: 0 }}
		>
			<CmsContent name="AccountNavigation">
				<Navigation />
			</CmsContent>
		</Paper>
	)
}
